import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import {
	MovementPageUserMovement,
	type MovementPageUserMovementQuery,
	type MovementPageUserMovementQueryVariables,
} from './movement.graphql';

export type MovementInfo = NonNullable<MovementPageUserMovementQuery['movement']>;

export async function getMovementInfo(
	slugOrId: string,
	{ gql: { fetch } }: UtilityContext,
): Promise<MovementInfo | undefined> {
	const { data } = await fetch<MovementPageUserMovementQuery, MovementPageUserMovementQueryVariables>({
		query: MovementPageUserMovement,
		variables: { slugOrId },
		rejectOnError: false,
	});
	return data?.movement ?? undefined;
}
